import { Row, Table } from '@atbay/cyber-components'

export interface TableRowContext<TData> {
    sortedRows: Row<TData>[]
    sortedIndex: number
    items: TData[]
}

export const getTableRowContext = <TData>(
    row: Row<TData>,
    table: Table<TData>
): TableRowContext<TData> => {
    const sortedRows = table.getRowModel().rows
    const indexByReference = sortedRows.indexOf(row)
    const sortedIndex =
        indexByReference !== -1
            ? indexByReference
            : sortedRows.findIndex((r) => r.id === row.id)
    const items = sortedRows.map((r) => r.original)

    return { sortedRows, sortedIndex, items }
}
